import { Typography, Box } from "@mui/material";

export const CenterBox = ({ type }) => {
  const contentMap = {
    // ✅ placeholders for future content
    profile: (
      <Typography variant="h6" color="primary">
        {/* Write something */}
      </Typography>
    ),
    admin: (
      <Typography variant="h6" color="primary">
        {/* Write something */}
      </Typography>
    ),
    chatApp: (
      <Typography variant="h6" color="primary">
        {/* Write something */}
      </Typography>
    ),
    sondertageApp: (
      <Typography variant="h6" color="primary">
        {/* Write something */}
      </Typography>
    ),
    eventManagerApp: (
      <Typography variant="h6" color="primary">
        {/* Write something */}
      </Typography>
    ),
    gatterApp: (
      <Typography variant="h6" color="primary">
        {/* Write something */}
      </Typography>
    ),
    bszFinder: (
      <Typography variant="h6" color="primary">
        Finde deinen Arbeitsort
      </Typography>
    ),
    bszPlanner: (
      <Typography variant="h4" fontWeight="bold" color="primary">
        {/* BSZ Planner */}
        {/* Write something */}
        In Entwicklung - jetzt nur für LP
      </Typography>
    ),
    askoma: (
      <Typography variant="h6" color="primary">
        {/* Write something */}
      </Typography>
    ),
  };

  const defaultContent = (
    <Typography variant="h4" fontWeight="bold" color="primary">
      Dashboard
    </Typography>
  );

  return (
    <Box
      sx={{
        flex: 1,
        textAlign: "center",
        whiteSpace: "nowrap",
      }}
    >
      {contentMap[type] ?? defaultContent}
    </Box>
  );
};
